import constate from "constate";
import { useForm } from "react-hook-form";
import { useLens } from "@hookform/lenses";
import type { ArtworkForm } from "@design-lab/shared/types";

function useTransfersArtworksFormCreator() {
  const form = useForm<ArtworkForm>({
    defaultValues: {
      currentPlacement: "front",
      selectedFrontPlacement: "front",
      back: {
        artworkId: "",
        size: {
          height: 0,
          width: 0
        }
      },
      front: {
        artworkId: "",
        size: {
          height: 0,
          width: 0
        }
      },
      frontLeftChest: {
        artworkId: "",
        size: {
          height: 0,
          width: 0
        }
      },
      info: {
        front: {
          enhancementTier: "full_enhancements",
          removeBackground: true,
          jiffyDesignServices: false
        },
        back: {
          enhancementTier: "full_enhancements",
          removeBackground: true,
          jiffyDesignServices: false
        }
      }
    },
    mode: "onChange"
  });

  const lens = useLens(form);

  return {
    form,
    lens
  };
}

export const [TransfersArtworksFormProvider, useTransfersArtworksForm] = constate(
  useTransfersArtworksFormCreator
);
